import axios from 'axios';
import {
  API_USERS_LOGIN,
  API_USERS_LOGIN_AZURE,
  API_USERS_LOGIN_GOOGLE,
  API_USERS_REFRESH_TOKEN
} from '../../services/api/apiConst';
import { manageObjectResponse } from './apiResponse';
import { getLogger } from '../logger';

const debug = getLogger('services:api:authApi');

export let login = (email, password, alternativeUrl) => {
  if (email && password) {
    const payload = { email, password };
    if (alternativeUrl) {
      return manageObjectResponse(axios.post(alternativeUrl, payload));
    }
    return manageObjectResponse(axios.post(`${API_USERS_LOGIN}`, payload));
  }

  debug.error('[login] email or password is empty. email: "%s" | password: "%s"', email, password);
};

export let loginGoogle = (email, accessToken) => {
  if (email && accessToken) {
    let payload = { email: email, accessToken: accessToken };
    return manageObjectResponse(axios.post(`${API_USERS_LOGIN_GOOGLE}`, payload, { preventInterceptors: true }));
  }
  debug.error('[loginGoogle] email(%s) or accessToken(%s) is empty', email, accessToken);
};

export let loginInClassroomWithAzure = accessToken => {
  if (accessToken) {
    const payload = { accessToken: accessToken };
    return manageObjectResponse(axios.post(API_USERS_LOGIN_AZURE, payload, { preventInterceptors: true }));
  }
  debug.error('[loginAzure] accessToken(%s) is empty', accessToken);
};

export let refreshToken = refreshToken => {
  const payload = {
    refreshToken
  };
  debug.error('[refreshToken] refreshToken is empty. refreshToken "%s"', refreshToken);
  return manageObjectResponse(axios.post(`${API_USERS_REFRESH_TOKEN}`, payload));
};
